export const PACKAGE_UNIT_PURCHASE_STATUSES = strings => {
  return {
    pending: strings.pending,
    ordered: strings.ordered,
    received: strings.received,
    canceled: strings.canceled
  }
}
